import { useMatrixDistributionContext } from '@app/components/products/ProductMatrix/context';
import { Button } from '@app/components/various/Button';
import { Form } from '@app/components/various/Form';
import { getOrderCurrency } from '@app/ducks';
import { getTotalPrice } from '@app/logic/price';
import { Preset, Product } from '@typings';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { AddDistributionButton } from './AddDistributionButton';
import {
  AdderCell,
  DistributionNameCell,
  PriceCell,
  TotalDistributionCountCell,
  TotalDistributionPriceCell,
} from './DistributionListElements';

interface Props {
  close: () => void;
  onSubmit: () => void;
  variant: Product.Standard;
  distributions: Preset[];
}

export const QuantitiesForm = ({ close, onSubmit, variant, distributions }: Props) => {
  const currency = useSelector(getOrderCurrency);
  const { quantitiesFormMethods } = useMatrixDistributionContext();
  const { t } = useTranslation(['common', 'orders', 'totals']);

  return (
    <Form className="flex flex-col gap-5" formMethods={quantitiesFormMethods} onSubmit={onSubmit}>
      <table>
        <thead className="border-b border-neutral-90">
          <tr>
            <th className="pb-1 pl-2 text-start body-5">{t('orders:distribution')}</th>
            <th className="pb-1 pl-2 text-start body-5" style={{ width: '80px' }}>
              {t('common:item_other')}
            </th>
            <th className="pb-1 pr-2 text-end body-5">
              {t('common:price')} [{currency.currency}]
            </th>
          </tr>
        </thead>
        <tbody>
          {distributions.map(preset => (
            <tr key={preset.id}>
              <DistributionNameCell name={preset.name} variant={variant} preset={preset} />
              <AdderCell id={preset.id} name={preset.name} />
              <PriceCell getTotalPrice={getTotalPrice(variant, currency)} cellId={preset.id} />
            </tr>
          ))}
        </tbody>
        <tfoot className="border-t border-neutral-90">
          <tr>
            <th className="pl-2 pt-1 text-start body-2">{t('totals:total_other')}</th>
            <TotalDistributionCountCell />
            <TotalDistributionPriceCell getTotalPrice={getTotalPrice(variant, currency)} />
          </tr>
        </tfoot>
      </table>

      <div className="flex justify-end gap-4">
        <Button color="secondary" onClick={close}>
          {t('common:cancel')}
        </Button>
        <AddDistributionButton />
      </div>
    </Form>
  );
};
